import { get } from 'lodash-es';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  Checkbox,
  FormFeedback,
  FormGroup,
  Label,
  Text,
  useConfiguredForm,
} from '../index';
type CheckboxFieldProps<TKeys extends string> = {
  id?: string;
  name: string;
  label: React.ReactNode;
  helperText?: string;
  formGroupClassName?: string;
  disabled?: boolean;
  asTextField?: boolean;
  translate: (key: TKeys) => string;
};
const CheckboxField = <TKeys extends string>({
  label,
  helperText,
  translate,
  formGroupClassName = 'mb-2',
  asTextField = true,
  ...props
}: CheckboxFieldProps<TKeys>) => {
  const methods = useFormContext();
  const errorMessage = get(methods.formState.errors, [
    ...props.name.split('.'),
    'message',
  ]) as TKeys;
  const configurationContext = useConfiguredForm();

  return (
    <FormGroup className={formGroupClassName}>
      {configurationContext.mode === 'WRITE' ? (
        <>
          {asTextField && (
            <div className='space-x-2 opacity-0'>
              <Label>{label}</Label>
            </div>
          )}
          <Checkbox
            {...props}
            id={props.id || props.name}
            label={label}
            {...methods.register(props.name)}
            isInvalid={!!errorMessage}
          />
        </>
      ) : (
        <div>
          <Label>{label}</Label>
          <Text heading='normal' weight='semi-bold'>
            {methods.getValues(props.name)
              ? translate('app.common.messages.yes' as TKeys)
              : translate('app.common.messages.no' as TKeys)}
          </Text>
        </div>
      )}

      {errorMessage ? (
        <FormFeedback invalid id={`${props.name}.error`}>
          {translate(errorMessage)}
        </FormFeedback>
      ) : helperText ? (
        <FormFeedback>{helperText}</FormFeedback>
      ) : null}
    </FormGroup>
  );
};

export default CheckboxField;
